export default "__VITE_PUBLIC_ASSET__5a32f2a2__"